import React, { useState, useEffect, useMemo } from "react";
import Footer from "../../components/navigation/footer";
import { Card, Space, Typography, Row, Col, Pagination, Input, Button, Collapse } from "antd";
import { FaTools } from "react-icons/fa";
import Loader from "../../components/ui/loader";


import { PlusOutlined, MinusCircleOutlined, SaveOutlined } from "@ant-design/icons"
import { IoIosArrowDropdown } from "react-icons/io";




function EditFaqs() {
    const API_URL = process.env.REACT_APP_API_URL;
    const { Panel } = Collapse;
    const BASE_URL = `${API_URL}`
    const [faqs, setFaqs] = useState([]);
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState({ text: "", type: "", visible: false });
    const [filters, setFilters] = useState({ category: "", faq_type: "" });
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 8;

    const filteredFaqs = useMemo(() => {
        return faqs.filter((f) => {
            return (
                (!filters.category || f.category === filters.category) &&
                (!filters.faq_type || f.faq_type === filters.faq_type)
            );
        });
    }, [faqs, filters]);
    const paginatedFaqs = useMemo(() => {
        const start = (currentPage - 1) * pageSize;
        return filteredFaqs.slice(start, start + pageSize);
    }, [filteredFaqs, currentPage]);


    const categories = [...new Set(faqs.map((f) => f.category))];
    const faqTypes = [...new Set(faqs.map((f) => f.faq_type))];

    useEffect(() => {
        fetchFaqs();


    }, [])


    //fetch faqs
    const fetchFaqs = async () => {
        try {
            setLoading(true);
            const res = await fetch(`${BASE_URL}/admin/faqs`, {
                credentials: "include",
                method: "GET"
            });

            if (!res.ok) {
                throw new Error("Server response not ok")
            }
            const faqs = await res.json();
            setFaqs(faqs)

            setLoading(false)

        } catch (error) {
            setLoading(false)
            console.log("Server error. Failed to fetch FAQs");
            setMessage({ text: "Server error. Failed to fetch FAQs", type: "error", visible: "false" })


        } finally {
            setLoading(false);
        }
        setTimeout(() => setMessage((prev) => ({ ...prev, visible: false })), 5000);

    };

    const handleDeleteFaq = (index) => {
        const globalIndex = (currentPage - 1) * pageSize + index;
        const updated = [...faqs];
        updated.splice(globalIndex, 1);
        setFaqs(updated);
    };

    const handleSave = (index) => {
        const globalIndex = (currentPage - 1) * pageSize + index;
        console.log("Saving FAQ:", faqs[globalIndex]);
    };


    const handleChange = (index, field, value) => {
        const updated = [...faqs];
        const globalIndex = (currentPage - 1) * pageSize + index;
        updated[globalIndex][field] = value;
        setFaqs(updated);
    };

    const handleAddFaq = () => {
        setFaqs([
            ...faqs,
            {
                faq_id: null,
                question: "",
                answer: "",
                category: "",
                faq_type: "",
                isNew: true,
            },
        ]);
        setCurrentPage(Math.ceil((faqs.length + 1) / pageSize));
    };



    return (
        <div>
            <main className="keep-footer-bottom">
                <Row className="marginRightNone">
                    <Col xs={24}>
                        <Card style={{ boxShadow: "0 2px 12px rgba(0,0,0,0.08)", border: "none" }}>
                            <Space className="d-flex gap-3 justify-content-start align-items-center">
                                <FaTools size={24} />
                                <Typography.Title level={3} style={{ margin: 0 }}>
                                    Edit FAQs
                                </Typography.Title>
                            </Space>
                        </Card>
                    </Col>
                </Row>

                <Row gutter={16} style={{ marginTop: 20 }}>
                    <Col md={6}>
                        <select
                            className="form-select"
                            value={filters.category}
                            onChange={(e) => {
                                setFilters({ ...filters, category: e.target.value });
                                setCurrentPage(1);
                            }}
                        >
                            <option value="">All Categories</option>
                            {categories.map((cat, i) => (
                                <option key={i} value={cat}>
                                    {cat}
                                </option>
                            ))}
                        </select>
                    </Col>
                    <Col md={6}>
                        <select
                            className="form-select"
                            value={filters.faq_type}
                            onChange={(e) => {
                                setFilters({ ...filters, faq_type: e.target.value });
                                setCurrentPage(1);
                            }}
                        >
                            <option value="">All FAQ Types</option>
                            {faqTypes.map((type, i) => (
                                <option key={i} value={type}>
                                    {type}
                                </option>
                            ))}
                        </select>
                    </Col>
                </Row>

                <div style={{ marginTop: 20, padding: "20px" }}>
                    <Collapse  bordered={false}
                        defaultActiveKey={['1']}

                        expandIcon={({ isActive }) => (
                            <IoIosArrowDropdown
                                style={{
                                    transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.2s",
                                    fontSize: "18px",
                                    color: "#039606"
                                }}
                            />
                        )} style={{ backgroundColor: "white" }}>
                        {paginatedFaqs.map((faq, index) => (
                            <Panel
                                className="faq-question-header"
                                header={faq.question || "New FAQ"}
                                key={index}
                                style={{
                                    marginBottom: "12px",
                                    border: "1px solid #e5e5e5",
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                    fontSize: "medium",

                                }}
                            >
                                <div style={{ backgroundColor: "white" }}>

                                    {/* question and answer */}
                                    <Row gutter={16}>
                                        <Col md={12}>
                                            <div className="form-floating mb-3">
                                                <input
                                                    value={faq.question}
                                                    required
                                                    className="form-control"
                                                    placeholder="Question"
                                                    id={`q-${index}`}
                                                    onChange={(e) =>
                                                        handleChange(index, "question", e.target.value)
                                                    }
                                                />
                                                <label htmlFor={`q-${index}`}>Question</label>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="form-floating mb-3">
                                                <textarea
                                                    value={faq.answer}
                                                    required
                                                    className="form-control"
                                                    style={{ height: "100px" }}
                                                    placeholder="Answer"
                                                    id={`a-${index}`}
                                                    onChange={(e) =>
                                                        handleChange(index, "answer", e.target.value)
                                                    }
                                                />
                                                <label htmlFor={`a-${index}`}>Answer</label>
                                            </div>
                                        </Col>
                                    </Row>

                                    {/* category and type */}
                                    <Row gutter={16}>
                                        <Col md={6}>
                                            <div className="form-floating mb-3">
                                                <select
                                                    className="form-select"
                                                    id={`c-${index}`}
                                                    value={faq.category}
                                                    onChange={(e) => handleChange(index, "category", e.target.value)}
                                                >
                                                    <option value="">Select Category</option>
                                                    {categories.map((cat, i) => (
                                                        <option key={i} value={cat}>
                                                            {cat}
                                                        </option>
                                                    ))}
                                                </select>
                                                <label htmlFor={`c-${index}`}>Category</label>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-floating mb-3">
                                                <select
                                                    className="form-select"
                                                    id={`t-${index}`}
                                                    value={faq.faq_type}
                                                    onChange={(e) => handleChange(index, "faq_type", e.target.value)}
                                                >
                                                    <option value="">Select FAQ Type</option>
                                                    {faqTypes.map((type, i) => (
                                                        <option key={i} value={type}>
                                                            {type}
                                                        </option>
                                                    ))}
                                                </select>
                                                <label htmlFor={`t-${index}`}>FAQ Type</label>
                                            </div>
                                        </Col>
                                        <Col md={12} className="d-flex justify-content-end align-items-center gap-2">
                                            <Button
                                                icon={<SaveOutlined />}
                                                type="primary"
                                                onClick={() => handleSave(index)}
                                            >
                                                Save
                                            </Button>
                                            <Button
                                                danger
                                                icon={<MinusCircleOutlined />}
                                                onClick={() => handleDeleteFaq(index)}
                                            >
                                                Remove
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>

                            </Panel>
                        ))}
                    </Collapse>

                    <div style={{ marginTop: "20px", display: "flex", justifyContent: "center" }}>
                        <Pagination
                            current={currentPage}
                            pageSize={pageSize}
                            total={filteredFaqs.length}
                            onChange={(page) => setCurrentPage(page)}
                        />
                    </div>

                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                        <Button icon={<PlusOutlined />} onClick={handleAddFaq}>
                            Add FAQ
                        </Button>
                    </div>
                </div>
            </main>
        </div>
    );


}

export default EditFaqs;